import { Diagnostic, linter } from '@codemirror/lint';
import jsonlint from 'jsonlint-mod';

import { getOffset, parseJsonLintError } from './ParseJsonLintError';

export function jsonLinter() {
  return linter(view => {
    const text = view.state.doc.toString();
    if (!text.trim()) {
      return [];
    }
    const diagnostics: Diagnostic[] = [];

    try {
      jsonlint.parse(text);
    } catch (e: any) {
      const errorMessage = e.message || 'JSON invalide';

      const position = parseJsonLintError(errorMessage);

      if (position) {
        const pos = getOffset(text, position.line, position.column);

        diagnostics.push({
          from: pos,
          to: pos + 1,
          severity: 'error',
          message: errorMessage,
        });
      } else {
        diagnostics.push({
          from: 0,
          to: text.length,
          severity: 'error',
          message: errorMessage,
        });
      }
    }
    return diagnostics;
  });
}
